// extracted by mini-css-extract-plugin
export default {"section":"MicropilesCompression_section__L6I2I","spaceBetween":"MicropilesCompression_spaceBetween__QIjVR","rightAlign":"MicropilesCompression_rightAlign__XW66r"};